function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M190.49 54.1665H187.56V57.9929H174.048V60.9288H184.469C183.111 62.2949 179.036 66.115 174.594 67.549V70.603C178.682 69.5456 182.442 66.7307 184.756 64.6901V60.9288H193.429V64.6901C195.743 66.7307 199.504 69.5456 203.591 70.603V67.549C199.148 66.115 195.074 62.2949 193.716 60.9288H204.645V57.9929H190.49V54.1665Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M130.314 76.4279H122.989V70.3346H129.428V67.3988H122.989V62.6377H130.314V59.7019H112.734V62.6377H120.059V67.3988H113.621V70.3346H120.059V76.4279H112.734V79.3637H130.314V76.4279Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M125.27 72.4648C125.728 73.0393 127.009 74.7857 127.434 75.9577L129.794 75.0982C129.152 73.3261 127.426 71.137 127.231 70.8933L125.27 72.4648Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M132.746 54.8179H110.301C108.839 54.8179 107.649 56.01 107.649 57.4742V81.7395C107.649 83.2047 108.839 84.3958 110.301 84.3958H132.746C134.208 84.3958 135.398 83.2047 135.398 81.7395V57.4742C135.398 56.01 134.208 54.8179 132.746 54.8179ZM132.468 81.4609H110.579V57.7537H132.468V81.4609Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M196.423 68.8977C196.506 68.7447 196.58 68.61 196.65 68.4854H193.299C192.439 69.9954 191.118 72.091 189.054 74.2498C186.99 72.091 185.668 69.9954 184.809 68.4854H181.458C181.528 68.61 181.602 68.7447 181.685 68.8977C182.494 70.3793 184.062 73.2363 186.936 76.239C184.038 78.6846 180.064 81.0038 174.596 82.4295V85.4551C181.059 83.8928 185.714 81.1311 189.054 78.2512C192.393 81.1311 197.049 83.8928 203.512 85.4551V82.4295C198.043 81.0038 194.07 78.6846 191.171 76.239C194.046 73.2363 195.614 70.3793 196.423 68.8977Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M215.601 77.652V68.6357C215.601 66.7591 214.438 65.5945 212.567 65.5945H208.067V68.5303H212.567C212.606 68.5303 212.639 68.5321 212.668 68.534C212.67 68.5624 212.671 68.5963 212.671 68.6357V77.652C212.671 77.74 212.684 78.4061 212.974 79.3032C210.93 80.6529 209.121 81.5023 207.949 81.9787V85.117C209.037 84.7414 211.514 83.7673 214.454 81.844C215.95 83.4897 218.699 84.9915 223.763 84.9915H238.516V82.0557H223.763C215.693 82.0557 215.601 77.8316 215.601 77.652Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M220.987 74.5494H226.158V79.0145H229.088V74.5494H233.99V76.8457H230.973V79.7815H234.055C235.635 79.7815 236.92 78.5426 236.92 77.0188V64.7222C236.92 63.0802 235.586 61.7442 233.948 61.7442H230.593C230.562 61.7103 230.529 61.6746 230.495 61.6398C232.099 60.4156 234.022 58.9495 234.611 58.507C235.778 57.631 235.542 56.58 235.442 56.2794C234.88 54.5907 232.282 54.5706 232.172 54.5706H218.446V57.5064H231.078C230.126 58.2312 228.993 59.0961 228.071 59.7998C226.267 58.6957 224.088 57.7528 222.805 57.7528V60.6887C223.345 60.6887 224.453 61.155 225.554 61.7442H221.406C218.299 61.7442 218.057 63.8581 218.057 64.5068V79.5002H220.987V74.5494ZM220.988 71.6136V69.5336H226.158V71.6136H220.988ZM229.088 69.5336H233.99V71.6136H229.088V69.5336ZM233.99 64.7222V66.5978H229.088V64.68H233.948C233.949 64.68 233.99 64.68 233.99 64.7222ZM221.406 64.68H226.158V66.5978H220.988L220.989 64.7039C221.086 64.691 221.222 64.68 221.406 64.68Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M215.431 57.6694C213.461 56.1456 210.955 54.6062 208.81 54.1426V57.1828C210.815 57.8508 213.597 59.7604 215.431 61.5206V57.6694Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M252.27 55.9834H248.905C247.773 57.663 245.669 59.7155 241.774 61.2897V64.427C248.379 62.0722 251.138 58.3758 252.27 55.9834Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M263.982 59.2601C266.779 60.8434 269.971 63.0627 272 64.8815V61.0789C269.151 58.8734 265.468 56.5579 262.734 55.3209V58.5811C262.946 58.692 263.164 58.8083 263.384 58.9275C262.805 59.4919 260.899 61.2319 257.748 63.0819C258.189 62.4286 258.462 61.6736 258.462 60.9937V54.4358H255.532V60.99C255.519 61.2118 255.202 61.6773 254.985 61.8101H251.187V64.7459H254.58C251.274 66.2908 247.09 67.6836 242.067 68.2654V71.2177C244.309 70.9749 246.394 70.5827 248.324 70.0916V81.6112C248.324 83.4035 249.78 84.8622 251.569 84.8622H265.66C267.448 84.8622 268.904 83.4035 268.904 81.6112V69.9981C268.904 68.2059 267.448 66.7471 265.66 66.7471H257.206C260.301 65.161 262.57 63.4998 263.982 62.3269V59.2601ZM251.254 74.7665H265.974V76.6944H251.254V74.7665ZM265.66 81.9264H251.569C251.399 81.9264 251.254 81.7817 251.254 81.6112V79.6302H265.974V81.6112C265.974 81.7817 265.83 81.9264 265.66 81.9264ZM265.974 69.9981V71.8316H251.254V69.9981C251.254 69.8277 251.399 69.6829 251.569 69.6829H265.66C265.83 69.6829 265.974 69.8277 265.974 69.9981Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M157.011 66.5519H168.912V63.616H157.011V54.1113H154.081V63.616H142.179V66.5519H154.081V81.6881H140.247V84.6239H170.845V81.6881H157.011V66.5519Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M55.7884 40.6228C49.5058 44.1441 41.8386 52.8929 41.8386 62.6029C41.8386 72.3119 47.1629 81.7012 56.4277 85.9693C41.5186 85.7558 33 74.6595 33 62.9226C33 51.1858 44.2877 40.6228 55.7884 40.6228Z",
  fill: "#82C2EB"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M80.4936 82.4479C61.0861 93.4635 38.5372 75.4061 45.246 54.5998C45.139 67.4032 61.1309 79.8648 75.2754 71.9911C91.5682 62.9225 84.5402 46.4906 82.0912 42.863C92.8457 46.9176 98.9162 71.9911 80.4936 82.4479Z",
  fill: "#82C2EB"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M81.9841 51.3983C83.0486 59.6138 78.4697 75.6187 60.2602 70.284C47.0914 66.4255 47.3758 49.7975 54.1906 44.1431C54.1906 44.1431 50.2509 57.6932 63.6685 61.9613C77.086 66.2294 81.9841 51.3983 81.9841 51.3983Z",
  fill: "#82C2EB"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M57.7051 38.0616C57.7051 38.0616 68.1404 37.9553 70.5904 46.1708C73.0394 54.3863 66.2236 59.9345 64.5199 60.0417C75.0623 60.3615 81.4638 53.4609 78.3636 44.1431C75.1693 34.5403 61.7517 34.7538 57.7051 38.0616Z",
  fill: "#EC6D65"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M85.9249 100.053C85.9249 102.233 76.3418 104 64.521 104C52.6993 104 43.1162 102.233 43.1162 100.053C43.1162 97.8718 52.6993 96.1052 64.521 96.1052C76.3418 96.1052 85.9249 97.8718 85.9249 100.053Z",
  fill: "#9FA0A0"
});

function SvgLogoMlit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMlit);
export default __webpack_public_path__ + "static/media/logo_mlit.17321cf5.svg";
export { ForwardRef as ReactComponent };